/**
 * RNC bundle subscriptions — multi-line cart add with welcome gifts (first bundle sub).
 */
(function () {
  'use strict';

  window.__rncBlockThemeDrawerPaint = function (cart) {
    if (!cart || !cart.items) return false;
    var i;
    for (i = 0; i < cart.items.length; i++) {
      var item = cart.items[i];
      var p = item.properties || {};
      if (p._rnc_gift === 'welcome' || p['_rnc_gift'] === 'welcome') return true;
      var bundleHandle = p._rnc_bundle || p['_rnc_bundle'] || '';
      if (!bundleHandle && item.handle && CONFIG.bundleHandles && CONFIG.bundleHandles.indexOf(item.handle) >= 0) {
        bundleHandle = item.handle;
      }
      if (bundleHandle) return true;
      if (
        p._rnc_subscribe === '1' ||
        p['_rnc_subscribe'] === '1' ||
        item.selling_plan_allocation
      ) {
        return true;
      }
    }
    return false;
  };

  window.RNC_BUNDLE_GIFTS = window.RNC_BUNDLE_GIFTS || {};

  var RNC_GIFT_HANDLES = [
    'free-apricot-seed-travel-pack-welcome-gift',
    'free-vita-rox-raspberry-welcome-gift',
    'free-vita-rox-peach-mango-welcome-gift',
    'free-apricot-seed-powder-8oz-welcome-gift',
    'free-lip-replenish-balm-apricot-luxe',
    'free-limited-edition-rnc-canvas-bag-welcome-gift',
  ];

  function isGiftProductMeta(handle, title) {
    var h = (handle || '').toLowerCase();
    var t = (title || '');
    if (h.indexOf('welcome-gift') >= 0) return true;
    if (t.indexOf('Welcome Gift') >= 0) return true;
    return RNC_GIFT_HANDLES.indexOf(h) >= 0;
  }

  // Strip welcome-gift products out of the predictive-search dropdown at the data source.
  (function patchSearchSuggestFetch() {
    if (window.__rncSearchFetchPatched || typeof window.fetch !== 'function') return;
    window.__rncSearchFetchPatched = true;
    var origFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/search/suggest') === -1) return origFetch(input, init);
      return origFetch(input, init).then(function (resp) {
        return resp
          .clone()
          .json()
          .then(function (data) {
            try {
              var results = data && data.resources && data.resources.results;
              if (results && Array.isArray(results.products)) {
                results.products = results.products.filter(function (p) {
                  return !isGiftProductMeta(p.handle, p.title);
                });
              }
            } catch (e) {}
            return new Response(JSON.stringify(data), {
              status: resp.status,
              statusText: resp.statusText,
              headers: resp.headers,
            });
          })
          .catch(function () {
            return resp;
          });
      });
    };
  })();

  // Safety net: remove welcome-gift cards from the full /search results page.
  function scrubSearchPageGifts() {
    if (location.pathname.indexOf('/search') !== 0) return;
    var anchors = document.querySelectorAll('a[href*="/products/"]');
    Array.prototype.forEach.call(anchors, function (a) {
      var href = (a.getAttribute('href') || '').toLowerCase();
      var isGift =
        href.indexOf('welcome-gift') >= 0 ||
        RNC_GIFT_HANDLES.some(function (h) {
          return href.indexOf('/products/' + h) >= 0;
        });
      if (!isGift) return;
      var card = a.closest(
        'li, article, .indiv-product-wrapper, .grid__item, .product-grid__item, .search-result, .search-results__item'
      );
      if (card) card.style.display = 'none';
    });
  }

  function initSearchPageScrub() {
    if (location.pathname.indexOf('/search') !== 0) return;
    scrubSearchPageGifts();
    var target = document.querySelector('#PageContainer') || document.body;
    if (!target || target.dataset.rncSearchScrub) return;
    target.dataset.rncSearchScrub = '1';
    var timer;
    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(scrubSearchPageGifts, 60);
    });
    observer.observe(target, { childList: true, subtree: true });
  }

  function readConfig() {
    var el = document.getElementById('rnc-bundle-gifts-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  var CONFIG = readConfig() || {
    bundleHandles: [],
    bundleKit: {},
    kits: {},
    defaultCadence: {},
    customerGiftEligible: true,
    promoCode: '',
    cartUpsell: {},
  };

  // One-time cart free shipping in drawer — $99 regardless of theme setting (theme uses $30).
  var DRAWER_FREE_SHIPPING_THRESHOLD_CENTS = 9900;

  function getDrawerFreeShippingThreshold() {
    return DRAWER_FREE_SHIPPING_THRESHOLD_CENTS;
  }

  function isBundleHandle(handle) {
    return CONFIG.bundleHandles && CONFIG.bundleHandles.indexOf(handle) >= 0;
  }

  function normalizeLineItemProperties(properties) {
    if (!properties) return {};
    if (typeof properties === 'object' && !Array.isArray(properties)) return properties;
    if (!Array.isArray(properties)) return {};
    var out = {};
    properties.forEach(function (entry) {
      if (entry && entry.key != null) out[entry.key] = entry.value;
    });
    return out;
  }

  function lineItemProperties(item) {
    return normalizeLineItemProperties(item && item.properties);
  }

  function planNameIsExcluded(name) {
    return String(name || '').toLowerCase().indexOf('lifetime') >= 0;
  }

  function resolveSellingPlanId(product, cadenceKey) {
    if (!product || !product.selling_plan_groups) return '';
    cadenceKey = String(cadenceKey || '60');
    if (cadenceKey === 'first') {
      return resolveFirstSellingPlanId(product);
    }
    var planId = '';
    product.selling_plan_groups.forEach(function (group) {
      if (planId) return;
      (group.selling_plans || []).forEach(function (plan) {
        if (planId) return;
        if (planNameIsExcluded(plan.name)) return;
        var name = (plan.name || '').toLowerCase();
        if (
          cadenceKey === '90' &&
          (name.indexOf('90') >= 0 || name.indexOf('2 month') >= 0 || name.indexOf('every 2') >= 0)
        )
          planId = String(plan.id);
        else if (cadenceKey === '60' && name.indexOf('60') >= 0) planId = String(plan.id);
        else if (
          cadenceKey === '30' &&
          (name.indexOf('30') >= 0 || name.indexOf('1 month') >= 0 || name.indexOf('monthly') >= 0)
        )
          planId = String(plan.id);
      });
    });
    if (!planId && product.selling_plan_groups[0] && product.selling_plan_groups[0].selling_plans[0]) {
      var fallback = product.selling_plan_groups[0].selling_plans[0];
      if (!planNameIsExcluded(fallback.name)) planId = String(fallback.id);
    }
    if (!planId && product.variants && product.variants[0]) {
      planId = resolveFirstSellingPlanId(product);
    }
    return planId;
  }

  function resolveFirstSellingPlanId(product) {
    if (!product || !product.variants || !product.variants[0]) return '';
    var variant = product.variants[0];
    var list = variant.selling_plan_allocations || [];
    var i;
    for (i = 0; i < list.length; i++) {
      var sp = list[i].selling_plan;
      if (!planNameIsExcluded(sp && sp.name)) {
        return String(list[i].selling_plan_id || (sp && sp.id) || '');
      }
    }
    if (!product.selling_plan_groups) return '';
    var planId = '';
    product.selling_plan_groups.forEach(function (group) {
      if (planId) return;
      (group.selling_plans || []).forEach(function (plan) {
        if (planId) return;
        if (!planNameIsExcluded(plan.name)) planId = String(plan.id);
      });
    });
    return planId;
  }

  function getCadenceForHandle(handle) {
    if (!isBundleHandle(handle)) return 'first';
    return (CONFIG.defaultCadence && CONFIG.defaultCadence[handle]) || '60';
  }

  function productHasSubscribePlans(product) {
    if (!product || !product.variants || !product.variants[0]) return false;
    var list = product.variants[0].selling_plan_allocations || [];
    return list.length > 0;
  }

  function getSubscribePriceCents(product, planId) {
    if (!product || !product.variants || !product.variants[0] || !planId) return null;
    var variant = product.variants[0];
    var list = variant.selling_plan_allocations || [];
    var i;
    for (i = 0; i < list.length; i++) {
      if (String(list[i].selling_plan_id) === String(planId)) {
        return list[i].price;
      }
    }
    return null;
  }

  function resolveSubscribeGridPrices(product) {
    if (!product || !productHasSubscribePlans(product)) return null;
    var handle = product.handle;
    var cadence = getCadenceForHandle(handle);
    var planId = resolveSellingPlanId(product, cadence);
    var onetime = product.variants[0].price;
    var subscribe = getSubscribePriceCents(product, planId);
    if (subscribe == null || onetime == null || subscribe >= onetime) {
      return { display: onetime, compare: 0 };
    }
    return { display: subscribe, compare: onetime };
  }

  function cartHasWelcomeGift(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(isWelcomeGiftLine);
  }

  function cartHasWelcomeGiftForBundle(cart, bundleHandle) {
    if (!cart || !cart.items || !bundleHandle) return false;
    return cart.items.some(function (item) {
      if (!isWelcomeGiftLine(item)) return false;
      return resolveGiftBundleHandle(item, cart) === bundleHandle;
    });
  }

  function promoDefaultOnetime() {
    return !!CONFIG.promoDefaultOnetime;
  }

  function isEligibleForWelcomeGifts() {
    if (promoDefaultOnetime()) return false;
    if (CONFIG.customerGiftEligible === false) return false;
    return true;
  }

  function getGiftLineItems(bundleHandle, quantity) {
    if (!isEligibleForWelcomeGifts()) return [];
    var tier = CONFIG.bundleKit[bundleHandle];
    if (!tier || !CONFIG.kits[tier]) return [];
    var qty = parseInt(quantity, 10) || 1;
    var variantIds = CONFIG.kits[tier].variantIds || [];
    return variantIds.map(function (vid) {
      return {
        id: parseInt(vid, 10),
        quantity: qty,
        properties: {
          _rnc_gift: 'welcome',
          _rnc_bundle: bundleHandle,
          _rnc_gift_tier: tier,
        },
      };
    });
  }

  function buildCartItems(opts) {
    var variantId = parseInt(opts.variantId, 10);
    var sellingPlanId = opts.sellingPlanId ? parseInt(opts.sellingPlanId, 10) : null;
    var bundleHandle = opts.bundleHandle || '';
    var isSubscribe = opts.isSubscribe !== false;
    var bundleQty = parseInt(opts.quantity, 10) || 1;

    var main = { id: variantId, quantity: bundleQty };
    if (isSubscribe && sellingPlanId) main.selling_plan = sellingPlanId;
    if (bundleHandle) {
      main.properties = { _rnc_bundle: bundleHandle };
      if (isSubscribe) main.properties._rnc_subscribe = '1';
    }

    var items = [main];
    if (isSubscribe && bundleHandle) {
      items = items.concat(getGiftLineItems(bundleHandle, bundleQty));
    }
    return items;
  }

  function getBundleQtyByHandle(cart) {
    var map = {};
    if (!cart || !cart.items) return map;
    cart.items.forEach(function (item) {
      if (!isBundleSubscribeLine(item)) return;
      var handle = resolveBundleHandleFromLine(item);
      if (!handle) return;
      map[handle] = (map[handle] || 0) + item.quantity;
    });
    return map;
  }

  function buildGiftQuantitySyncUpdates(cart) {
    if (!cart || !cart.items) return null;
    var bundleQty = getBundleQtyByHandle(cart);
    var updates = {};
    var giftGroups = {};

    cart.items.forEach(function (item) {
      if (!isWelcomeGiftLine(item)) return;
      var handle = resolveGiftBundleHandle(item, cart);
      var groupKey = handle + ':' + item.variant_id;
      if (!giftGroups[groupKey]) {
        giftGroups[groupKey] = { handle: handle, lines: [] };
      }
      giftGroups[groupKey].lines.push(item);
    });

    Object.keys(giftGroups).forEach(function (groupKey) {
      var group = giftGroups[groupKey];
      if (!group.handle) return;
      var expected = bundleQty[group.handle] || 0;
      group.lines.forEach(function (item, index) {
        var targetQty = index === 0 ? expected : 0;
        if (item.quantity !== targetQty) {
          updates[item.key] = targetQty;
        }
      });
    });

    return Object.keys(updates).length ? updates : null;
  }

  function syncGiftQuantitiesAndRender(cart) {
    if (promoDefaultOnetime()) return Promise.resolve(cart);
    return syncGiftQuantities(cart).then(function (updatedCart) {
      var finalCart = updatedCart || cart;
      if (cartHasBundleGiftLines(finalCart)) {
        rncRenderCartDrawer(finalCart);
      }
      return finalCart;
    });
  }

  function syncGiftQuantities(cart) {
    if (promoDefaultOnetime()) return Promise.resolve(cart);
    var updates = buildGiftQuantitySyncUpdates(cart);
    if (!updates) return Promise.resolve(cart);

    var bundleQty = getBundleQtyByHandle(cart);
    var hasActiveBundle = Object.keys(bundleQty).some(function (handle) {
      return bundleQty[handle] > 0;
    });
    if (hasActiveBundle) {
      var giftItems = (cart.items || []).filter(isWelcomeGiftLine);
      var allGiftsZeroed =
        giftItems.length > 0 &&
        giftItems.every(function (item) {
          return updates[item.key] === 0;
        });
      if (allGiftsZeroed) return Promise.resolve(cart);
    }

    return applyCartUpdates(updates);
  }

  function refreshCartDrawer(cart) {
    var headerCounts = document.querySelectorAll('.cart-item-count-header--quantity');
    if (cart && headerCounts.length) {
      headerCounts.forEach(function (el) {
        el.textContent = String(cart.item_count);
      });
    }
    document.querySelectorAll('.cart-item-count-header').forEach(function (el) {
      el.textContent = cart ? String(cart.item_count) : '0';
    });
  }

  function isWelcomeGiftLine(item) {
    if (!item) return false;
    var p = lineItemProperties(item);
    if (p._rnc_gift === 'welcome' || p['_rnc_gift'] === 'welcome') return true;
    var handle = (item.handle || '').toLowerCase();
    if (handle.indexOf('welcome-gift') >= 0) return true;
    var title = item.product_title || '';
    if (title.indexOf('Welcome Gift') >= 0 || title.indexOf('(Welcome Gift)') >= 0) return true;
    return false;
  }

  function resolveGiftBundleHandle(item, cart) {
    var p = lineItemProperties(item);
    if (p._rnc_bundle) return p._rnc_bundle;
    if (p['_rnc_bundle']) return p['_rnc_bundle'];
    var bundleQty = getBundleQtyByHandle(cart);
    var handles = Object.keys(bundleQty).filter(function (h) {
      return bundleQty[h] > 0;
    });
    if (handles.length === 1) return handles[0];
    return '';
  }

  function resolveBundleHandleFromLine(item) {
    if (!item) return '';
    var p = lineItemProperties(item);
    if (p._rnc_bundle) return p._rnc_bundle;
    if (p['_rnc_bundle']) return p['_rnc_bundle'];
    if (item.handle && isBundleHandle(item.handle)) return item.handle;
    return '';
  }

  function isBundleSubscribeLine(item) {
    if (!item) return false;
    var bundleHandle = resolveBundleHandleFromLine(item);
    if (!bundleHandle) return false;
    var p = lineItemProperties(item);
    return !!(p._rnc_subscribe === '1' || p['_rnc_subscribe'] === '1' || item.selling_plan_allocation);
  }

  function isSubscriptionPurchaseLine(item) {
    if (!item) return false;
    if (isWelcomeGiftLine(item)) return false;
    if (item.selling_plan_allocation) return true;
    return isBundleSubscribeLine(item);
  }

  function cartHasOneTimePurchaseLines(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (item) {
      if (isWelcomeGiftLine(item)) return false;
      return !isSubscriptionPurchaseLine(item);
    });
  }

  function cartHasBundleGiftLines(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(isWelcomeGiftLine) || cart.items.some(isBundleSubscribeLine);
  }

  function cartHasBundleLines(cart) {
    if (!cart || !cart.items) return false;
    return cart.items.some(function (item) {
      return !!resolveBundleHandleFromLine(item);
    });
  }

  function buildCascadeRemovalUpdates(cart, removedItem) {
    if (!removedItem || !cart || !cart.items) return null;
    if (isWelcomeGiftLine(removedItem)) return null;

    var updates = {};
    updates[removedItem.key] = 0;

    if (isBundleSubscribeLine(removedItem)) {
      var bundleHandle = resolveBundleHandleFromLine(removedItem);
      cart.items.forEach(function (item) {
        if (!isWelcomeGiftLine(item)) return;
        var giftBundle = resolveGiftBundleHandle(item, cart);
        if (!bundleHandle || giftBundle === bundleHandle) {
          updates[item.key] = 0;
        }
      });
    }

    return updates;
  }

  function applyCartUpdates(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates }),
    }).then(function (r) {
      return r.json().then(function (data) {
        window.__rncLastCart = data;
        return data;
      });
    });
  }

  var productFetchCache = {};

  function fetchProductByHandle(handle) {
    if (!handle) return Promise.resolve(null);
    if (productFetchCache[handle]) return Promise.resolve(productFetchCache[handle]);
    return fetchUpsellProductByHandle(handle).then(function (product) {
      if (product) productFetchCache[handle] = product;
      return product;
    });
  }

  function lineHasActiveSubscription(item) {
    return !!(item && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan);
  }

  function lineIsSubscribeMode(item) {
    if (!item) return false;
    if (lineHasActiveSubscription(item)) return true;
    return isBundleSubscribeLine(item);
  }

  function isCartPageContext() {
    return !!document.getElementById('cartform');
  }

  function getPurchaseToggleRow(el) {
    if (!el) return null;
    return el.closest('li') || el.closest('tr.line-item');
  }

  function isDrawerCartRow(row) {
    return !!(row && row.closest('.cart-items'));
  }

  function finalizeAfterPurchaseTypeChange(cart) {
    if (isCartPageContext()) {
      window.location.reload();
      return Promise.resolve(cart);
    }
    return fastFinalizeCartDrawer(cart);
  }

  function applyPromoToggleRestrictions(wrap, item) {
    if (!wrap || !promoDefaultOnetime()) return;
    wrap.querySelectorAll('[data-purchase-mode="subscribe"]').forEach(function (btn) {
      btn.hidden = true;
    });
    if (!lineIsSubscribeMode(item)) {
      syncPurchaseToggleUi(getPurchaseToggleRow(wrap), false);
    }
  }

  function syncPurchaseToggleUi(li, isSubscribe) {
    var wrap = li.querySelector('[data-rnc-purchase-toggle]');
    if (!wrap) return;
    wrap.classList.remove('hide', 'rnc-cart-purchase-toggle--loading');
    wrap.classList.toggle('rnc-cart-purchase-toggle--subscribe', isSubscribe);
    wrap.classList.toggle('rnc-cart-purchase-toggle--onetime', !isSubscribe);
    wrap.querySelectorAll('[data-purchase-mode]').forEach(function (btn) {
      var mode = btn.getAttribute('data-purchase-mode');
      var selected = mode === 'subscribe' ? isSubscribe : !isSubscribe;
      btn.setAttribute('aria-pressed', selected ? 'true' : 'false');
      btn.classList.toggle('rnc-cart-purchase-toggle__btn--selected', selected);
    });
  }

  function hidePurchaseToggle(li) {
    var wrap = li && li.querySelector('[data-rnc-purchase-toggle]');
    if (wrap) wrap.classList.add('hide');
  }

  function configurePurchaseToggleForLine(li, item) {
    if (!li || !item || isWelcomeGiftLine(item)) {
      if (li) hidePurchaseToggle(li);
      return Promise.resolve();
    }

    if (promoDefaultOnetime()) {
      hidePurchaseToggle(li);
      return Promise.resolve();
    }

    var wrap = li.querySelector('[data-rnc-purchase-toggle]');
    if (!wrap) return Promise.resolve();

    var bundleHandle = resolveBundleHandleFromLine(item);
    if (bundleHandle && isBundleHandle(bundleHandle)) {
      syncPurchaseToggleUi(li, lineIsSubscribeMode(item));
      applyPromoToggleRestrictions(wrap, item);
      return Promise.resolve();
    }

    if (lineHasActiveSubscription(item)) {
      syncPurchaseToggleUi(li, true);
      applyPromoToggleRestrictions(wrap, item);
      return Promise.resolve();
    }

    return fetchProductByHandle(item.handle).then(function (product) {
      if (!product || !productHasSubscribePlans(product)) {
        hidePurchaseToggle(li);
        return;
      }
      syncPurchaseToggleUi(li, false);
      applyPromoToggleRestrictions(wrap, item);
    });
  }

  function enhanceCartPagePurchaseToggles(cart) {
    if (!isCartPageContext() || !cart || !cart.items || !cart.items.length) return Promise.resolve();
    var form = document.getElementById('cartform');
    if (!form) return Promise.resolve();
    var rows = form.querySelectorAll('tr.line-item');
    var promises = [];

    cart.items.forEach(function (item, index) {
      var row = form.querySelector('tr[data-line-key="' + item.key + '"]') || rows[index];
      if (!row) return;
      row.setAttribute('data-line-key', item.key);
      var handle = resolveBundleHandleFromLine(item);
      if (handle) row.setAttribute('data-rnc-bundle', handle);
      promises.push(configurePurchaseToggleForLine(row, item));
    });

    return Promise.all(promises);
  }

  function enhanceCartDrawerPurchaseToggles(cart) {
    if (!cart || !cart.items || !cart.items.length) return Promise.resolve();
    var root = getCartDrawerRoot();
    if (!root) return Promise.resolve();
    var cartItems = root.querySelector('.cart-items');
    if (!cartItems) return Promise.resolve();

    var rows = cartItems.querySelectorAll('li:not(.rnc-cart-drawer-group--head)');
    var promises = [];

    cart.items.forEach(function (item, index) {
      var li = root.querySelector('li[data-line-key="' + item.key + '"]') || rows[index];
      if (!li) return;
      li.setAttribute('data-line-key', item.key);
      promises.push(configurePurchaseToggleForLine(li, item));
    });

    return Promise.all(promises);
  }

  function buildLinePropertiesForMode(item, isSubscribe) {
    var existing = lineItemProperties(item);
    var bundleHandle = resolveBundleHandleFromLine(item);
    if (!bundleHandle) return existing;

    var props = {};
    Object.keys(existing).forEach(function (key) {
      if (key.indexOf('_') === 0) return;
      props[key] = existing[key];
    });
    props._rnc_bundle = bundleHandle;
    if (isSubscribe) props._rnc_subscribe = '1';
    return props;
  }

  function postCartChange(payload) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          var msg = (data && data.description) || (data && data.message) || 'Could not update cart';
          throw new Error(msg);
        }
        window.__rncLastCart = data;
        return data;
      });
    });
  }

  function resetCheckoutSpinner() {
    var btn = document.querySelector('.cart-button-checkout');
    if (!btn) return;
    var text = btn.querySelector('.cart-button-checkout-text');
    var spinner = btn.querySelector('.cart-button-checkout-spinner');
    if (text) text.classList.remove('hide');
    if (spinner) spinner.classList.add('hide');
  }

  function setDrawerBusy(busy) {
    var root = getCartDrawerRoot();
    if (!root) return;
    root.classList.toggle('rnc-drawer-busy', !!busy);
    if (!busy) resetCheckoutSpinner();
  }

  function markLineRemoving(li) {
    if (!li) return;
    li.classList.add('rnc-cart-line--removing');
  }

  function optimisticHideGiftLinesInDrawer() {
    var root = getCartDrawerRoot();
    if (!root) return;
    root.querySelectorAll('li[data-rnc-gift="1"]').forEach(markLineRemoving);
    root.querySelectorAll('.rnc-cart-drawer-group--head').forEach(function (head) {
      if ((head.textContent || '').indexOf('Free gifts') >= 0) {
        head.classList.add('rnc-cart-line--removing');
      }
    });
  }

  function snapshotGiftLinesForBundle(cart, bundleHandle) {
    if (!cart || !bundleHandle || !cart.items) return;
    var items = cart.items.filter(function (item) {
      if (!isWelcomeGiftLine(item)) return false;
      return resolveGiftBundleHandle(item, cart) === bundleHandle;
    });
    if (!items.length) return;
    window.__rncGiftLineSnapshot = window.__rncGiftLineSnapshot || {};
    window.__rncGiftLineSnapshot[bundleHandle] = items.map(function (item) {
      return {
        key: item.key,
        id: item.id,
        variant_id: item.variant_id,
        product_title: item.product_title,
        variant_title: item.variant_title,
        image: item.image,
        url: item.url,
        quantity: item.quantity,
        final_line_price: item.final_line_price,
      };
    });
  }

  function optimisticRestoreGiftLinesInDrawer(bundleHandle, quantity) {
    var root = getCartDrawerRoot();
    if (!root) return;
    var cartItems = root.querySelector('.cart-items');
    if (!cartItems) return;

    clearOptimisticLineStates();
    cartItems.querySelectorAll('li[data-rnc-gift-optimistic="1"]').forEach(function (el) {
      el.remove();
    });

    var snap =
      window.__rncGiftLineSnapshot && window.__rncGiftLineSnapshot[bundleHandle];
    if (!snap || !snap.length) return;

    var hasGiftsHeader = false;
    cartItems.querySelectorAll('.rnc-cart-drawer-group--head').forEach(function (head) {
      if ((head.textContent || '').indexOf('Free gifts') >= 0) hasGiftsHeader = true;
    });
    if (!hasGiftsHeader) {
      appendGroupHeader(cartItems, 'Free gifts');
    }

    var qty = parseInt(quantity, 10) || 1;
    snap.forEach(function (item) {
      var optimistic = {
        key: item.key || 'rnc-opt-' + item.variant_id,
        id: item.id,
        variant_id: item.variant_id,
        product_title: item.product_title,
        variant_title: item.variant_title,
        image: item.image,
        url: item.url,
        quantity: qty,
        final_line_price: 0,
      };
      renderCartLine(cartItems, optimistic, { isGift: true });
      var li = cartItems.lastElementChild;
      if (li) li.setAttribute('data-rnc-gift-optimistic', '1');
    });
    setGiftSectionBusy(true);
  }

  function setGiftSectionBusy(busy) {
    var root = getCartDrawerRoot();
    if (!root) return;
    root.querySelectorAll('.rnc-cart-drawer-group--head').forEach(function (head) {
      if ((head.textContent || '').indexOf('Free gifts') < 0) return;
      head.classList.toggle('rnc-cart-gifts-section--busy', !!busy);
    });
  }

  function notifySubscribePlanChanged() {
    try {
      if (typeof window.__rncOnSubscribePlanChanged === 'function') {
        window.__rncOnSubscribePlanChanged();
      }
    } catch (e) {}
  }

  function fetchCartJson() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (fresh) {
        window.__rncLastCart = fresh;
        return fresh;
      });
  }

  function fetchCartJsonWhenUpdated(minItemCount, attempt) {
    attempt = attempt || 0;
    var maxAttempts = 3;
    var delayMs = 60;
    return fetchCartJson().then(function (cart) {
      if (!cart) return cart;
      if (!minItemCount || cart.item_count >= minItemCount || attempt >= maxAttempts - 1) {
        return cart;
      }
      return new Promise(function (resolve) {
        setTimeout(resolve, delayMs);
      }).then(function () {
        return fetchCartJsonWhenUpdated(minItemCount, attempt + 1);
      });
    });
  }

  function openCartDrawerShell() {
    var wrapper = document.querySelector('#cartSlideoutWrapper');
    if (!wrapper) return;
    var cartDrawerTop = document.querySelector('.cart-drawer__top');
    var cartDrawerStatus = document.querySelector('.js-cart-drawer-status');
    if (cartDrawerStatus && cartDrawerTop) {
      cartDrawerStatus.textContent = 'Item added to your cart';
    }
    wrapper.dispatchEvent(new CustomEvent('cart:open'));
    window.__rncBoosterRemounting = false;
  }

  function refreshCartAfterAdd(cart, opts) {
    opts = opts || {};
    if (!cart) return Promise.resolve(cart);
    window.__rncLastCart = cart;
    rncRenderCartDrawer(cart, { refreshMode: opts.refreshMode || 'fast' });
    if (opts.openDrawer !== false) openCartDrawerShell();
    return Promise.resolve(cart);
  }

  function clearOptimisticLineStates() {
    var root = getCartDrawerRoot();
    if (!root) return;
    root.querySelectorAll('.rnc-cart-line--removing').forEach(function (el) {
      el.classList.remove('rnc-cart-line--removing');
    });
  }

  function resolveLineItemFromCart(lineKey, li) {
    var cart = window.__rncLastCart;
    if (cart && cart.items) {
      if (lineKey) {
        var byKey = cart.items.find(function (i) {
          return i.key === lineKey;
        });
        if (byKey) return Promise.resolve(byKey);
      }
      if (li) {
        var byLi = resolveCartLineItem(cart, li);
        if (byLi) return Promise.resolve(byLi);
      }
    }
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (fresh) {
        window.__rncLastCart = fresh;
        if (lineKey) {
          var found = fresh.items.find(function (i) {
            return i.key === lineKey;
          });
          if (found) return found;
        }
        return resolveCartLineItem(fresh, li);
      });
  }

  function prefetchCartProducts(cart) {
    if (!cart || !cart.items) return;
    // These prefetches only warm the per-line Subscribe/One-time toggle lookups.
    // During the promo the toggle is hidden, so skip the extra product fetches
    // entirely (meaningful on mobile latency).
    if (promoDefaultOnetime()) return;
    cart.items.forEach(function (item) {
      if (!isWelcomeGiftLine(item) && item.handle) {
        fetchProductByHandle(item.handle);
      }
    });
  }

  function fastFinalizeCartDrawer(cart) {
    window.__rncLastCart = cart;
    clearOptimisticLineStates();
    var useRncPaint =
      !cart ||
      !cart.items ||
      !cart.items.length ||
      cartHasBundleGiftLines(cart) ||
      cartHasBundleLines(cart) ||
      cart.items.some(isSubscriptionPurchaseLine);

    if (useRncPaint) {
      rncRenderCartDrawer(cart, { refreshMode: 'fast' });
    } else if (window.theme && typeof window.theme.updateCartDrawer === 'function') {
      return Promise.resolve(window.theme.updateCartDrawer(cart)).then(function () {
        return enhanceCartDrawerPurchaseToggles(cart);
      });
    } else {
      rncRenderCartDrawer(cart, { refreshMode: 'fast' });
    }
    refreshCartDrawer(cart);
    setDrawerBusy(false);
    return Promise.resolve(cart);
  }

  function changeLinePurchaseType(item, mode, productCached) {
    var isSubscribe = mode === 'subscribe';
    var bundleHandle = resolveBundleHandleFromLine(item);
    var cadence = bundleHandle ? getCadenceForHandle(bundleHandle) : 'first';

    var productPromise = productCached
      ? Promise.resolve(productCached)
      : fetchProductByHandle(item.handle);

    return productPromise
      .then(function (product) {
        if (!product) throw new Error('Product not available');

        var sellingPlan = null;
        if (isSubscribe) {
          var planId = resolveSellingPlanId(product, cadence);
          if (!planId) throw new Error('Subscribe option is not available for this item');
          sellingPlan = parseInt(planId, 10);
        }

        var payload = {
          id: item.key,
          quantity: item.quantity,
          selling_plan: isSubscribe ? sellingPlan : null,
        };

        if (bundleHandle) {
          payload.properties = buildLinePropertiesForMode(item, isSubscribe);
        }

        return postCartChange(payload);
      })
      .then(function (cart) {
        if (isSubscribe && bundleHandle) {
          notifySubscribePlanChanged();
          if (cartHasWelcomeGiftForBundle(cart, bundleHandle)) {
            setGiftSectionBusy(false);
            return cart;
          }
          return ensureWelcomeGiftsInCart(cart, bundleHandle, item.quantity);
        }
        return cart;
      })
      .then(function (cart) {
        setGiftSectionBusy(false);
        return syncGiftQuantities(cart);
      })
      .then(function (finalCart) {
        return finalizeAfterPurchaseTypeChange(finalCart || cart);
      });
  }

  function bindCartPurchaseToggle() {
    if (window.__rncCartPurchaseToggleBound) return;
    window.__rncCartPurchaseToggleBound = true;

    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-purchase-mode]');
      if (!btn || !btn.closest('[data-rnc-purchase-toggle]')) return;

      var wrap = btn.closest('[data-rnc-purchase-toggle]');
      var row = getPurchaseToggleRow(btn);
      if (!row) return;
      if (!isDrawerCartRow(row) && !row.closest('#cartform')) return;
      if (row.getAttribute('data-rnc-gift') === '1') return;
      if (wrap.classList.contains('rnc-cart-purchase-toggle--loading')) return;

      var mode = btn.getAttribute('data-purchase-mode');
      if (promoDefaultOnetime() && mode === 'subscribe') return;
      var isSubscribe = mode === 'subscribe';
      if (wrap.classList.contains('rnc-cart-purchase-toggle--subscribe') && isSubscribe) return;
      if (wrap.classList.contains('rnc-cart-purchase-toggle--onetime') && !isSubscribe) return;

      e.preventDefault();
      e.stopPropagation();

      var lineKey = row.getAttribute('data-line-key');
      var bundleHandle = row.getAttribute('data-rnc-bundle');
      var inDrawer = isDrawerCartRow(row);

      syncPurchaseToggleUi(row, isSubscribe);
      if (inDrawer) {
        invalidateDrawerFreeShippingCache();
        if (!isSubscribe && bundleHandle) {
          if (window.__rncLastCart) {
            snapshotGiftLinesForBundle(window.__rncLastCart, bundleHandle);
          }
          optimisticHideGiftLinesInDrawer();
        } else if (isSubscribe && bundleHandle) {
          var qtyInput = row.querySelector('.cart-item-quantity, .quantity-selector');
          var lineQty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
          optimisticRestoreGiftLinesInDrawer(bundleHandle, lineQty);
        }
        setDrawerBusy(true);
      } else {
        wrap.classList.add('rnc-cart-purchase-toggle--loading');
      }

      var subscribeUiReleased = false;
      function releaseSubscribeToggleUi() {
        if (subscribeUiReleased || !isSubscribe) return;
        subscribeUiReleased = true;
        wrap.classList.remove('rnc-cart-purchase-toggle--loading');
        if (inDrawer) setDrawerBusy(false);
      }
      if (isSubscribe && inDrawer) {
        window.__rncOnSubscribePlanChanged = releaseSubscribeToggleUi;
      }

      resolveLineItemFromCart(lineKey, row)
        .then(function (item) {
          if (!item) throw new Error('Cart item not found');
          var productCached = productFetchCache[item.handle] || null;
          return changeLinePurchaseType(item, mode, productCached).then(function (finalCart) {
            if (inDrawer) syncDrawerFreeShippingBar(finalCart);
            return finalCart;
          });
        })
        .catch(function (err) {
          if (inDrawer) {
            clearOptimisticLineStates();
            setGiftSectionBusy(false);
            if (window.__rncLastCart) {
              fastFinalizeCartDrawer(window.__rncLastCart);
            }
          }
          alert((err && err.message) || 'Could not update purchase option. Please try again.');
        })
        .finally(function () {
          window.__rncOnSubscribePlanChanged = null;
          if (!isCartPageContext()) {
            wrap.classList.remove('rnc-cart-purchase-toggle--loading');
            setDrawerBusy(false);
          }
        });
    });
  }

  function resolveCartLineItem(cart, row) {
    if (!cart || !row) return null;
    var key = row.getAttribute('data-line-key');
    if (key) {
      return cart.items.find(function (item) {
        return item.key === key;
      });
    }
    var form = row.closest('#cartform');
    if (form) {
      var pageRows = form.querySelectorAll('tr.line-item');
      var pageIdx = Array.prototype.indexOf.call(pageRows, row);
      if (pageIdx >= 0) return cart.items[pageIdx] || null;
    }
    var ul = row.closest('.cart-items');
    if (!ul) return null;
    var index = Array.prototype.indexOf.call(ul.children, row);
    var nonHeaderIndex = 0;
    for (var i = 0; i < ul.children.length; i++) {
      var child = ul.children[i];
      if (child.classList.contains('rnc-cart-drawer-group--head')) continue;
      if (child === row) {
        return cart.items[nonHeaderIndex] || null;
      }
      nonHeaderIndex++;
    }
    return cart.items[index] || null;
  }

  function applyUpdatesAndRender(updates, options) {
    options = options || {};
    setDrawerBusy(true);
    return applyCartUpdates(updates)
      .then(function (newCart) {
        window.__rncLastCart = newCart;
        return syncGiftQuantities(newCart);
      })
      .then(function (synced) {
        var finalCart = synced || window.__rncLastCart;
        if (options.removedLi) {
          options.removedLi.remove();
        }
        return fastFinalizeCartDrawer(finalCart);
      })
      .catch(function (err) {
        clearOptimisticLineStates();
        setDrawerBusy(false);
        throw err;
      });
  }

  function isRncPaintedDrawerLine(li) {
    return !!(li && li.hasAttribute('data-line-key'));
  }

  function handleDrawerLineQtyChange(li, delta) {
    var lineKey = li.getAttribute('data-line-key');
    setDrawerBusy(true);
    return resolveLineItemFromCart(lineKey, li)
      .then(function (item) {
        if (!item) {
          setDrawerBusy(false);
          return window.__rncLastCart;
        }
        var newQty = item.quantity + delta;
        if (newQty < 1) {
          return handleCartLineRemove(li);
        }
        var updates = {};
        updates[item.key] = newQty;
        return applyUpdatesAndRender(updates);
      });
  }

  function handleCartLineRemove(li) {
    var lineKey = li.getAttribute('data-line-key');
    markLineRemoving(li);
    setDrawerBusy(true);

    return resolveLineItemFromCart(lineKey, li)
      .then(function (item) {
        if (!item) {
          setDrawerBusy(false);
          li.classList.remove('rnc-cart-line--removing');
          return window.__rncLastCart;
        }
        if (isWelcomeGiftLine(item)) {
          setDrawerBusy(false);
          li.classList.remove('rnc-cart-line--removing');
          return window.__rncLastCart;
        }

        if (isBundleSubscribeLine(item)) {
          optimisticHideGiftLinesInDrawer();
        }

        var cart = window.__rncLastCart;
        var updates = buildCascadeRemovalUpdates(cart, item);
        if (!updates) {
          updates = {};
          updates[item.key] = 0;
        }

        return applyUpdatesAndRender(updates, { removedLi: li });
      })
      .catch(function () {
        clearOptimisticLineStates();
        setDrawerBusy(false);
      });
  }

  function bindCartLineGuards() {
    if (window.__rncCartLineGuards) return;
    window.__rncCartLineGuards = true;

    document.addEventListener(
      'click',
      function (e) {
        var removeBtn = e.target.closest('#cart-item-remove-button');
        var decreaseBtn = e.target.closest('.cart-item-decrease');
        var increaseBtn = e.target.closest('.cart-item-increase');
        if (!removeBtn && !decreaseBtn && !increaseBtn) return;

        var li = (removeBtn || decreaseBtn || increaseBtn).closest('li');
        if (!li || !li.closest('.cart-items')) return;

        if (li.getAttribute('data-rnc-gift') === '1') {
          e.preventDefault();
          e.stopImmediatePropagation();
          return;
        }

        if (isRncPaintedDrawerLine(li) && (removeBtn || increaseBtn || decreaseBtn)) {
          e.preventDefault();
          e.stopImmediatePropagation();
          if (removeBtn) {
            handleCartLineRemove(li);
          } else {
            handleDrawerLineQtyChange(li, increaseBtn ? 1 : -1);
          }
          return;
        }

        if (!window.__rncCartHasBundleGifts) return;

        if (removeBtn) {
          e.preventDefault();
          e.stopImmediatePropagation();
          handleCartLineRemove(li);
          return;
        }

        if (decreaseBtn) {
          var input = li.querySelector('.cart-item-quantity');
          var qty = input ? parseInt(input.value, 10) || 1 : 1;
          if (qty <= 1) {
            e.preventDefault();
            e.stopImmediatePropagation();
            handleCartLineRemove(li);
          }
        }
      },
      true
    );
  }

  function appendGroupHeader(cartItems, label) {
    var li = document.createElement('li');
    li.className = 'rnc-cart-drawer-group--head';
    li.innerHTML = '<p class="rnc-cart-drawer-group__label">' + label + '</p>';
    cartItems.appendChild(li);
  }

  function renderCartLine(cartItems, item, opts) {
    opts = opts || {};
    var isGift = opts.isGift || isWelcomeGiftLine(item);
    var li = cloneCartLineTemplate();
    if (!li) return;

    var title = li.querySelector('.cart-item-product-title');
    var price = li.querySelector('.cart-item-price');
    var img = li.querySelector('.cart-item-image');
    var qty = li.querySelector('.cart-item-quantity');
    var plan = li.querySelector('.cart-item-selling-plan');
    var variantTitle = li.querySelector('.cart-item-variant-title');
    var article = li.querySelector('.cart-item');
    var props = li.querySelector('.cart-item-drawer-properties');
    var removeWrap = li.querySelector('.cart-item-remove-button-container');

    li.setAttribute('data-line-key', item.key);

    if (title) {
      title.textContent = item.product_title;
      title.title = item.product_title;
    }
    if (price) {
      price.innerHTML = isGift ? '<span class="rnc-cart-gift-free">Free</span>' : formatMoney(item.final_line_price);
    }
    if (img) {
      if (item.image) {
        img.src = sizedImageUrl(item.image, 90);
        img.alt = item.product_title || '';
        img.setAttribute('decoding', 'async');
        img.classList.remove('d-none');
      } else {
        img.classList.add('d-none');
      }
    }
    if (qty && !isGift) {
      qty.value = String(item.quantity);
      qty.setAttribute('name', 'updates[]');
    }
    if (plan) {
      if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan) {
        plan.classList.remove('hide');
        plan.textContent = item.selling_plan_allocation.selling_plan.name;
      } else {
        plan.classList.add('hide');
        plan.textContent = '';
      }
    }
    if (variantTitle && item.variant_title) {
      variantTitle.classList.remove('hide');
      variantTitle.textContent = item.variant_title;
    }
    if (article) article.classList.add('id-' + item.id);
    if (props) props.innerHTML = '';

    li.querySelectorAll('.cart-item-link').forEach(function (a) {
      a.setAttribute('href', item.url);
    });

    var qtyWrap = li.querySelector('.cart-item--quantity-wrapper');
    var qtyRemoveWrap = li.querySelector('.cart-item--quantity-remove-wrapper');

    if (isGift) {
      li.setAttribute('data-rnc-gift', '1');
      if (removeWrap) removeWrap.style.display = 'none';
      if (qtyRemoveWrap) {
        if (qtyWrap) {
          qtyWrap.classList.add('rnc-cart-gift-qty--locked');
          qtyWrap.innerHTML = '';
        }
      }
    } else {
      if (qtyWrap) {
        qtyWrap.setAttribute('data-stock-count', '9999');
        qtyWrap.setAttribute('data-inventory-policy', 'continue');
        qtyWrap.setAttribute('data-inventory-management', '');
      }
      if (resolveBundleHandleFromLine(item)) {
        li.setAttribute('data-rnc-bundle', resolveBundleHandleFromLine(item));
      } else if (isSubscriptionPurchaseLine(item)) {
        li.setAttribute('data-rnc-subscribe-line', '1');
      }
      if (promoDefaultOnetime()) {
        hidePurchaseToggle(li);
      } else {
        configurePurchaseToggleForLine(li, item);
      }
    }

    cartItems.appendChild(li);
  }

  function formatMoney(cents) {
    if (window.theme && typeof window.theme.formatMoney === 'function') {
      return window.theme.formatMoney(cents);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  // Serve right-sized images from the Shopify CDN. Cuts mobile bytes dramatically
  // vs. loading full-resolution product photos into ~64px / ~150px slots.
  function sizedImageUrl(url, width) {
    if (!url || typeof url !== 'string') return url || '';
    if (url.indexOf('cdn.shopify.com') < 0 && url.indexOf('/cdn/shop/') < 0) return url;
    if (/[?&]width=/.test(url)) return url;
    var dpr = window.devicePixelRatio && window.devicePixelRatio > 1 ? 2 : 1;
    var target = Math.round(width * dpr);
    return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + target;
  }

  function getCartDrawerRoot() {
    return document.getElementById('cartSlideoutWrapper') || document.querySelector('#cartSlideoutAside');
  }

  function cloneCartLineTemplate() {
    var tpl = document.getElementById('cart-item-template');
    if (!tpl) return null;
    var wrap = document.createElement('div');
    wrap.innerHTML = tpl.innerHTML.trim();
    return wrap.querySelector('li');
  }

  /** Reliable drawer paint for multi-line bundle adds (does not use cart?view=compare). */
  function rncRenderCartDrawer(cart, opts) {
    opts = opts || {};
    var refreshMode = opts.refreshMode || 'full';
    var root = getCartDrawerRoot();
    if (!root || !cart) return false;

    var cartItems = root.querySelector('.cart-items');
    var emptyNotices = root.querySelectorAll('.cart-empty-box');
    var footer = root.querySelector('.cart-drawer__footer');
    var checkoutEls = footer
      ? footer.querySelectorAll(
          '.ajax-cart--total-price, .cart-button-checkout, .cart-price-text, .ajax-cart--cart-original-price, .slide-checkout-buttons'
        )
      : [];

    if (!cart.items || !cart.items.length) {
      emptyNotices.forEach(function (el) {
        el.classList.remove('hide');
      });
      checkoutEls.forEach(function (el) {
        el.classList.add('hide');
      });
      if (footer) footer.classList.add('hide');
      if (cartItems) cartItems.innerHTML = '';
      return true;
    }

    emptyNotices.forEach(function (el) {
      el.classList.add('hide');
    });
    checkoutEls.forEach(function (el) {
      el.classList.remove('hide');
    });
    if (footer) footer.classList.remove('hide');

    if (!cartItems) return false;
    cartItems.innerHTML = '';

    var subs = [];
    var gifts = [];
    var other = [];

    cart.items.forEach(function (item) {
      if (isWelcomeGiftLine(item)) gifts.push(item);
      else if (isSubscriptionPurchaseLine(item)) subs.push(item);
      else other.push(item);
    });

    if (subs.length) {
      appendGroupHeader(cartItems, 'Subscription purchases');
      subs.forEach(function (item) {
        renderCartLine(cartItems, item, { isGift: false });
      });
    }

    if (gifts.length) {
      appendGroupHeader(cartItems, 'Free gifts');
      gifts.forEach(function (item) {
        renderCartLine(cartItems, item, { isGift: true });
      });
      var giftBundles = {};
      gifts.forEach(function (item) {
        var h = resolveGiftBundleHandle(item, cart);
        if (h) giftBundles[h] = true;
      });
      Object.keys(giftBundles).forEach(function (h) {
        snapshotGiftLinesForBundle(cart, h);
      });
    }

    other.forEach(function (item) {
      renderCartLine(cartItems, item, { isGift: false });
    });

    root.querySelectorAll('.js-cart-total').forEach(function (el) {
      el.innerHTML = formatMoney(cart.total_price);
    });

    var originalPrice = root.querySelector('.cart-item-original-total-price');
    if (originalPrice) {
      if (cart.original_total_price > cart.total_price) {
        originalPrice.innerHTML = formatMoney(cart.original_total_price);
        originalPrice.classList.remove('d-none');
        originalPrice.classList.add('d-block');
      } else {
        originalPrice.classList.add('d-none');
        originalPrice.classList.remove('d-block');
      }
    }

    var initial = document.getElementById('initial-cart');
    if (initial) {
      try {
        initial.textContent = JSON.stringify(cart);
      } catch (e) {}
    }

    refreshCartDrawer(cart);
    window.__rncCartHasBundleGifts = cartHasBundleGiftLines(cart);
    window.__rncLastCart = cart;
    applyGiftRowUi();
    refreshBoosterSideCart(cart, { forceRemount: refreshMode === 'full' });
    syncDrawerFreeShippingBar(cart);
    renderRncUpsellFallback(cart);
    if (!promoDefaultOnetime()) {
      enhanceCartDrawerPurchaseToggles(cart);
    }
    prefetchCartProducts(cart);
    return cartItems.children.length > 0;
  }

  function cartDrawerNeedsRepaint(cart) {
    var root = getCartDrawerRoot();
    if (!root || !cart || !cart.items) return false;
    var cartItems = root.querySelector('.cart-items');
    if (!cartItems) return false;
    var rows = cartItems.querySelectorAll('li:not(.rnc-cart-drawer-group--head)');
    return rows.length > cart.items.length;
  }

  function scheduleCartDrawerRepaint(cart) {
    if (!cart || !cartHasBundleGiftLines(cart)) return;
    window.__rncLastCart = cart;
    var root = getCartDrawerRoot();
    [0, 200].forEach(function (ms) {
      setTimeout(function () {
        if (!window.__rncLastCart) return;
        if (root && root.classList.contains('rnc-drawer-busy')) return;
        if (ms > 0 && !cartDrawerNeedsRepaint(window.__rncLastCart)) {
          refreshBoosterSideCart(window.__rncLastCart);
          syncDrawerFreeShippingBar(window.__rncLastCart);
          return;
        }
        rncRenderCartDrawer(window.__rncLastCart);
      }, ms);
    });
  }

  function initCartDrawerDedupeObserver() {
    var root = getCartDrawerRoot();
    if (!root) return;
    var cartItems = root.querySelector('.cart-items');
    if (!cartItems || cartItems.dataset.rncDedupeObserver) return;
    cartItems.dataset.rncDedupeObserver = '1';

    var timer;
    var observer = new MutationObserver(function () {
      if (!window.__rncLastCart || !cartHasBundleGiftLines(window.__rncLastCart)) return;
      if (!cartDrawerNeedsRepaint(window.__rncLastCart)) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        rncRenderCartDrawer(window.__rncLastCart);
      }, 40);
    });
    observer.observe(cartItems, { childList: true });
  }

  function syncBoosterCartMeta(cart) {
    if (!cart || !window.essentialOrderValueBoosterMeta) return;
    window.essentialOrderValueBoosterMeta.cartItems = cart.items || [];
    if ('cartProducts' in window.essentialOrderValueBoosterMeta) {
      window.essentialOrderValueBoosterMeta.cartProducts = (cart.items || []).map(function (item) {
        return JSON.stringify({
          handle: item.handle,
          product_id: item.product_id,
          id: item.id,
          title: item.product_title,
        });
      });
    }
  }

  function boosterHasUpsellProducts() {
    var root = getCartDrawerRoot();
    if (!root) return false;
    var booster = root.querySelector('.order-value-booster-side-cart');
    if (!booster) return false;
    return !!(
      booster.querySelector('[class*="free_shipping_card_product_"]') ||
      booster.querySelector('[class*="free_shipping_products_wrapper_"] [class*="free_shipping_card_product_"]') ||
      booster.querySelector('.essential_product_slider_glide__slide')
    );
  }

  function getUpsellConfig() {
    return CONFIG.cartUpsell || {};
  }

  function getCartLineHandles(cart) {
    var handles = [];
    if (!cart || !cart.items) return handles;
    cart.items.forEach(function (item) {
      if (isWelcomeGiftLine(item)) return;
      if (item.handle) handles.push(item.handle);
    });
    return handles;
  }

  function expandHandleSet(handles, aliases) {
    var set = {};
    (handles || []).forEach(function (h) {
      if (!h) return;
      set[h] = true;
      if (aliases && aliases[h]) set[aliases[h]] = true;
      if (aliases) {
        Object.keys(aliases).forEach(function (key) {
          if (aliases[key] === h) set[key] = true;
        });
      }
    });
    return set;
  }

  function getBundleUpsellConfig(handle, cfg) {
    if (!handle || !cfg.bundles) return null;
    if (cfg.bundles[handle]) return cfg.bundles[handle];
    var aliases = cfg.aliases || {};
    if (aliases[handle] && cfg.bundles[aliases[handle]]) return cfg.bundles[aliases[handle]];
    return null;
  }

  function buildUpsellExcludeSet(cart) {
    var cfg = getUpsellConfig();
    var aliases = cfg.aliases || {};
    var cartHandles = getCartLineHandles(cart);
    var exclude = expandHandleSet(cartHandles, aliases);

    cartHandles.forEach(function (h) {
      var bundleCfg = getBundleUpsellConfig(h, cfg);
      if (!bundleCfg || !bundleCfg.components) return;
      bundleCfg.components.forEach(function (component) {
        exclude[component] = true;
        if (aliases[component]) exclude[aliases[component]] = true;
      });
    });

    if (cart && cart.items) {
      cart.items.forEach(function (item) {
        if (item.product_id) exclude['id:' + item.product_id] = true;
      });
    }

    return exclude;
  }

  function getDominantCartCategory(cart) {
    var cfg = getUpsellConfig();
    var counts = {};
    getCartLineHandles(cart).forEach(function (h) {
      var bundle = getBundleUpsellConfig(h, cfg);
      var comp = cfg.components && cfg.components[h];
      var cat = (bundle && bundle.category) || (comp && comp.category) || '';
      if (cat) counts[cat] = (counts[cat] || 0) + 1;
    });
    var top = '';
    var topCount = 0;
    Object.keys(counts).forEach(function (cat) {
      if (counts[cat] > topCount) {
        top = cat;
        topCount = counts[cat];
      }
    });
    return top;
  }

  function buildUpsellCandidateScores(cart) {
    var cfg = getUpsellConfig();
    var aliases = cfg.aliases || {};
    var exclude = buildUpsellExcludeSet(cart);
    var cartHandles = getCartLineHandles(cart);
    var cartHandleSet = expandHandleSet(cartHandles, aliases);
    var scored = {};

    function addCandidate(handle, score) {
      if (!handle || exclude[handle] || cartHandleSet[handle]) return;
      if (aliases[handle] && (exclude[aliases[handle]] || cartHandleSet[aliases[handle]])) return;
      scored[handle] = Math.max(scored[handle] || 0, score);
    }

    cartHandles.forEach(function (h) {
      var comp = cfg.components && cfg.components[h];
      if (comp && comp.upgradeTo) {
        comp.upgradeTo.forEach(function (u) {
          addCandidate(u, 100);
        });
      }
      if (comp && comp.related) {
        comp.related.forEach(function (r) {
          addCandidate(r, 40);
        });
      }
    });

    cartHandles.forEach(function (h) {
      var bundle = getBundleUpsellConfig(h, cfg);
      if (bundle && bundle.crossSell) {
        bundle.crossSell.forEach(function (c) {
          addCandidate(c, 50);
        });
      }
    });

    (cfg.defaultCrossSell || []).forEach(function (c) {
      addCandidate(c, 25);
    });

    return { scored: scored, exclude: exclude, maxProducts: cfg.maxProducts || 4 };
  }

  function isUpsellProductExcluded(product, exclude, cart) {
    if (!product || !product.handle) return true;
    var cfg = getUpsellConfig();
    var aliases = cfg.aliases || {};
    if (exclude[product.handle]) return true;
    if (aliases[product.handle] && exclude[aliases[product.handle]]) return true;
    if (product.id && exclude['id:' + product.id]) return true;
    if (product.available === false) return true;
    return isComponentOfCartBundle(product.handle, cart);
  }

  function isComponentOfCartBundle(handle, cart) {
    var cfg = getUpsellConfig();
    return getCartLineHandles(cart).some(function (cartHandle) {
      var bundle = getBundleUpsellConfig(cartHandle, cfg);
      return bundle && bundle.components && bundle.components.indexOf(handle) >= 0;
    });
  }

  function scoreUpsellProduct(product, baseScore, cart) {
    var cfg = getUpsellConfig();
    var dominant = getDominantCartCategory(cart);
    var score = baseScore || 0;
    var bundle = getBundleUpsellConfig(product.handle, cfg);
    var comp = cfg.components && cfg.components[product.handle];
    var cat = (bundle && bundle.category) || (comp && comp.category) || '';
    if (dominant && cat && cat !== dominant) score += 25;
    if (isComponentOfCartBundle(product.handle, cart)) score -= 100;
    return score;
  }

  function fetchUpsellProductByHandle(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) return null;
        return r.json();
      })
      .catch(function () {
        return null;
      });
  }

  function fetchUpsellProductsByHandles(handles) {
    var unique = [];
    var seen = {};
    (handles || []).forEach(function (h) {
      if (h && !seen[h]) {
        seen[h] = true;
        unique.push(h);
      }
    });
    return Promise.all(unique.map(fetchUpsellProductByHandle)).then(function (list) {
      return list.filter(Boolean);
    });
  }

  function fetchShopifyRelatedProducts(cart, limit) {
    var anchors = (cart.items || []).filter(function (item) {
      return !isWelcomeGiftLine(item) && item.product_id;
    });
    if (!anchors.length) return Promise.resolve([]);

    return Promise.all(
      anchors.slice(0, 2).map(function (item) {
        return fetch(
          '/recommendations/products.json?product_id=' +
            item.product_id +
            '&limit=' +
            (limit || 8) +
            '&intent=related',
          { credentials: 'same-origin' }
        )
          .then(function (r) {
            return r.json();
          })
          .catch(function () {
            return { products: [] };
          });
      })
    ).then(function (results) {
      var products = [];
      var seen = {};
      results.forEach(function (data) {
        (data.products || []).forEach(function (p) {
          if (p && p.id && !seen[p.id]) {
            seen[p.id] = true;
            products.push(p);
          }
        });
      });
      return products;
    });
  }

  var __rncUpsellCache = { key: null, promise: null };

  function cartUpsellSignature(cart) {
    return getCartLineHandles(cart).slice().sort().join('|');
  }

  function buildRankedUpsellProducts(cart) {
    var key = cartUpsellSignature(cart);
    if (__rncUpsellCache.key === key && __rncUpsellCache.promise) {
      return __rncUpsellCache.promise;
    }
    var promise = buildRankedUpsellProductsUncached(cart);
    __rncUpsellCache.key = key;
    __rncUpsellCache.promise = promise;
    promise.catch(function () {
      if (__rncUpsellCache.key === key) {
        __rncUpsellCache.key = null;
        __rncUpsellCache.promise = null;
      }
    });
    return promise;
  }

  function buildRankedUpsellProductsUncached(cart) {
    var rec = buildUpsellCandidateScores(cart);
    var cfg = getUpsellConfig();
    var handleList = Object.keys(rec.scored).sort(function (a, b) {
      return rec.scored[b] - rec.scored[a];
    });
    (cfg.defaultCrossSell || []).forEach(function (handle) {
      if (handle && handleList.indexOf(handle) < 0) handleList.push(handle);
    });

    return fetchUpsellProductsByHandles(handleList)
      .then(function (curated) {
        return fetchShopifyRelatedProducts(cart, 8).then(function (related) {
          return { curated: curated, related: related, rec: rec };
        });
      })
      .then(function (result) {
        var merged = [];
        var seenIds = {};
        var rec = result.rec;

        result.curated.sort(function (a, b) {
          return (rec.scored[b.handle] || 0) - (rec.scored[a.handle] || 0);
        });

        result.curated.forEach(function (p) {
          if (isUpsellProductExcluded(p, rec.exclude, cart)) return;
          if (seenIds[p.id]) return;
          seenIds[p.id] = true;
          merged.push({ product: p, score: scoreUpsellProduct(p, rec.scored[p.handle] || 0, cart) });
        });

        result.related.forEach(function (p) {
          if (isUpsellProductExcluded(p, rec.exclude, cart)) return;
          if (seenIds[p.id]) return;
          seenIds[p.id] = true;
          merged.push({ product: p, score: scoreUpsellProduct(p, 10, cart) });
        });

        merged.sort(function (a, b) {
          return b.score - a.score;
        });

        return merged.slice(0, rec.maxProducts).map(function (entry) {
          return entry.product;
        });
      });
  }

  function syncUpsellSectionHeading() {
    var root = getCartDrawerRoot();
    if (!root) return;
    var heading = root.querySelector('.rnc-cart-drawer-upsell__heading');
    var fallback = root.querySelector('.rnc-cart-drawer-upsell-fallback');
    if (!heading) return;

    var hasUpsell = !!(fallback && !fallback.hidden && fallback.querySelector('.rnc-cart-drawer-upsell-card'));

    if (hasUpsell) {
      heading.removeAttribute('hidden');
    } else {
      heading.setAttribute('hidden', '');
    }
  }

  function clearUpsellFallback() {
    var root = getCartDrawerRoot();
    if (!root) return;
    var fallback = root.querySelector('.rnc-cart-drawer-upsell-fallback');
    var wrap = root.querySelector('.rnc-cart-drawer-upsell-wrap');
    if (fallback) {
      fallback.innerHTML = '';
      fallback.setAttribute('hidden', '');
    }
    if (wrap) wrap.classList.remove('rnc-cart-drawer-upsell-wrap--fallback');
  }

  function renderUpsellFallbackCard(product) {
    var img =
      (product.featured_image && product.featured_image) ||
      (product.images && product.images[0]) ||
      '';
    var price = formatMoney(product.price);
    var title = product.title || '';
    var variantId = product.variants && product.variants[0] ? product.variants[0].id : '';
    var handle = product.handle || '';

    return (
      '<div class="rnc-cart-drawer-upsell-card" data-handle="' +
      handle +
      '" data-variant-id="' +
      variantId +
      '">' +
      (img
        ? '<img class="rnc-cart-drawer-upsell-card__img" src="' +
          sizedImageUrl(img, 168) +
          '" alt="" width="168" height="168" loading="lazy" decoding="async">'
        : '<div class="rnc-cart-drawer-upsell-card__img"></div>') +
      '<div class="rnc-cart-drawer-upsell-card__meta">' +
      '<p class="rnc-cart-drawer-upsell-card__title">' +
      title +
      '</p>' +
      '<p class="rnc-cart-drawer-upsell-card__price">' +
      price +
      '</p>' +
      '</div>' +
      '<button type="button" class="rnc-cart-drawer-upsell-card__add">Add to cart</button>' +
      '</div>'
    );
  }

  function bindUpsellFallbackActions(container) {
    if (!container || container.dataset.rncUpsellBound) return;
    container.dataset.rncUpsellBound = '1';

    container.addEventListener('click', function (e) {
      var btn = e.target.closest('.rnc-cart-drawer-upsell-card__add');
      if (!btn) return;
      var card = btn.closest('.rnc-cart-drawer-upsell-card');
      var variantId = card ? card.getAttribute('data-variant-id') : '';
      if (!variantId) return;

      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
      })
        .then(function (r) {
          return r.json();
        })
        .then(function () {
          return fetch('/cart.js', { credentials: 'same-origin' });
        })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          btn.disabled = false;
          if (cartHasBundleGiftLines(cart)) {
            return syncGiftQuantitiesAndRender(cart);
          }
          rncRenderCartDrawer(cart);
          return cart;
        })
        .catch(function () {
          btn.disabled = false;
        });
    });
  }

  function bindUpsellCarouselNav(container) {
    if (!container || container.dataset.rncCarouselBound) return;
    container.dataset.rncCarouselBound = '1';

    container.addEventListener('click', function (e) {
      var prev = e.target.closest('.rnc-cart-drawer-upsell-nav--prev');
      var next = e.target.closest('.rnc-cart-drawer-upsell-nav--next');
      if (!prev && !next) return;
      e.preventDefault();
      var track = container.querySelector('.rnc-cart-drawer-upsell-track');
      if (!track) return;
      var card = track.querySelector('.rnc-cart-drawer-upsell-card');
      var step = card ? card.offsetWidth + 12 : 180;
      track.scrollBy({ left: prev ? -step : step, behavior: 'smooth' });
    });
  }

  function renderRncUpsellFallback(cart) {
    if (!cart || !cart.items || !cart.items.length) {
      clearUpsellFallback();
      syncUpsellSectionHeading();
      return Promise.resolve();
    }

    var root = getCartDrawerRoot();
    if (!root) return Promise.resolve();
    var fallback = root.querySelector('.rnc-cart-drawer-upsell-fallback');
    var wrap = root.querySelector('.rnc-cart-drawer-upsell-wrap');
    if (!fallback) return Promise.resolve();

    return buildRankedUpsellProducts(cart)
      .then(function (products) {
        if (!products.length) {
          clearUpsellFallback();
          syncUpsellSectionHeading();
          return;
        }

        fallback.innerHTML =
          '<div class="rnc-cart-drawer-upsell-carousel">' +
          '<button type="button" class="rnc-cart-drawer-upsell-nav rnc-cart-drawer-upsell-nav--prev" aria-label="Previous recommendations">&lsaquo;</button>' +
          '<div class="rnc-cart-drawer-upsell-track">' +
          products.map(renderUpsellFallbackCard).join('') +
          '</div>' +
          '<button type="button" class="rnc-cart-drawer-upsell-nav rnc-cart-drawer-upsell-nav--next" aria-label="Next recommendations">&rsaquo;</button>' +
          '</div>';
        fallback.removeAttribute('hidden');
        if (wrap) wrap.classList.add('rnc-cart-drawer-upsell-wrap--fallback');
        bindUpsellFallbackActions(fallback);
        bindUpsellCarouselNav(fallback);
        syncUpsellSectionHeading();
      })
      .catch(function () {
        syncUpsellSectionHeading();
      });
  }

  function nudgeBoosterObserver() {
    var root = getCartDrawerRoot();
    if (!root) return;
    var cartItems = root.querySelector('.cart-items');
    if (!cartItems) return;
    var nudge = document.createComment('rnc-booster-nudge');
    cartItems.appendChild(nudge);
    nudge.remove();
  }

  function refreshBoosterSideCart(cart, options) {
    options = options || {};
    if (cart) syncBoosterCartMeta(cart);

    var root = getCartDrawerRoot();
    if (!root) return;
    var booster = root.querySelector('.order-value-booster-side-cart');
    if (!booster) return;

    var hasProducts = boosterHasUpsellProducts();

    var hasWrapper = booster.querySelector('[class*="free_shipping_card_wrapper_"]');

    if (options.forceRemount && !hasProducts && !window.__rncBoosterRemounting) {
      window.__rncBoosterRemounting = true;
      if (hasWrapper) {
        hasWrapper.remove();
      }
      if (window.freeShippingBarConfigs) {
        window.freeShippingCardInitiated = false;
      }
      nudgeBoosterObserver();
      setTimeout(function () {
        window.__rncBoosterRemounting = false;
      }, 1000);
    }

    if (!hasProducts && typeof pollCartTotalEssentialApps === 'function' && !wrapUsesRncFallback()) {
      try {
        pollCartTotalEssentialApps();
      } catch (e) {}
    }

    syncUpsellSectionHeading();
    if (cart) renderRncUpsellFallback(cart);
    syncDrawerFreeShippingBar(cart || window.__rncLastCart);
  }

  function wrapUsesRncFallback() {
    var root = getCartDrawerRoot();
    if (!root) return false;
    var wrap = root.querySelector('.rnc-cart-drawer-upsell-wrap');
    return !!(wrap && wrap.classList.contains('rnc-cart-drawer-upsell-wrap--fallback'));
  }

  function syncDrawerFreeShippingBar(cart) {
    var root = getCartDrawerRoot();
    if (!root) return;

    var showBar = cartHasOneTimePurchaseLines(cart);
    var wrappers = root.querySelectorAll(
      '.order-value-booster-side-cart [class*="free_shipping_card_wrapper_"]'
    );

    if (showBar) {
      root.classList.remove('rnc-drawer-shipping-suppressed');
      wrappers.forEach(function (wrapper) {
        wrapper.classList.add('rnc-drawer-shipping-hidden');
      });
    } else {
      root.classList.add('rnc-drawer-shipping-suppressed');
      wrappers.forEach(function (wrapper) {
        wrapper.classList.add('rnc-drawer-shipping-hidden');
      });
    }

    renderDrawerFreeShippingBar(cart);
    syncUpsellSectionHeading();
  }

  function buildFreeShippingCacheKey(cart) {
    var total = cart ? cart.total_price || 0 : 0;
    var mode = cartHasOneTimePurchaseLines(cart) ? 'onetime' : 'sub';
    return mode + ':' + total;
  }

  function invalidateDrawerFreeShippingCache() {
    var root = getCartDrawerRoot();
    if (!root) return;
    var wrap = root.querySelector('[data-rnc-free-shipping-wrap]');
    if (!wrap) return;
    wrap.removeAttribute('data-rnc-free-ship-key');
    wrap.removeAttribute('data-rnc-free-ship-total');
  }

  function renderDrawerFreeShippingBar(cart) {
    var root = getCartDrawerRoot();
    if (!root) return;
    var wrap = root.querySelector('[data-rnc-free-shipping-wrap]');
    if (!wrap) return;
    var target = wrap.querySelector('[data-rnc-free-shipping]');
    if (!target) return;

    if (!cartHasOneTimePurchaseLines(cart)) {
      wrap.setAttribute('hidden', '');
      target.innerHTML = '';
      wrap.removeAttribute('data-rnc-free-ship-key');
      wrap.removeAttribute('data-rnc-free-ship-total');
      return;
    }

    var cacheKey = buildFreeShippingCacheKey(cart);
    if (
      wrap.getAttribute('data-rnc-free-ship-key') === cacheKey &&
      target.querySelector('.cart-free-shipping-encouragement')
    ) {
      wrap.removeAttribute('hidden');
      return;
    }

    wrap.removeAttribute('hidden');
    wrap.setAttribute('data-rnc-free-ship-key', cacheKey);
    applyFallbackBar();

    function applyFallbackBar() {
      var threshold = getDrawerFreeShippingThreshold();
      var total = cart ? cart.total_price || 0 : 0;
      var remaining = threshold - total;
      var achievedMsg = CONFIG.freeShippingAchievedMessage || 'You qualify for free shipping!';
      if (remaining <= 0) {
        target.innerHTML =
          '<div class="cart-free-shipping-encouragement">' +
          '<p>' +
          achievedMsg +
          '</p>' +
          '<div class="cart-free-shipping-encouragement__bar--bg">' +
          '<div class="cart-free-shipping-encouragement__bar--progress" style="width:100%"></div>' +
          '</div></div>';
        return;
      }
      var template =
        CONFIG.freeShippingMessage || "You're only <price> away from free shipping!";
      var msg = template
        .replace(/<price>/gi, formatMoney(remaining))
        .replace(/&lt;price&gt;/gi, formatMoney(remaining));
      var pct = Math.min(100, Math.max(0, Math.round((total / threshold) * 100)));
      target.innerHTML =
        '<div class="cart-free-shipping-encouragement">' +
        '<p>' +
        msg +
        '</p>' +
        '<div class="cart-free-shipping-encouragement__bar--bg">' +
        '<div class="cart-free-shipping-encouragement__bar--progress" style="width:' +
        pct +
        '%"></div>' +
        '</div></div>';
    }

    var threshold = getDrawerFreeShippingThreshold();
    var total = cart ? cart.total_price || 0 : 0;
    if (threshold - total > 0) {
      var progress = target.querySelector('.cart-free-shipping-encouragement__bar--progress');
      if (progress && (progress.style.width === '100%' || progress.style.width === '100')) {
        applyFallbackBar();
      }
    }
  }

  function initDrawerFreeShippingObserver() {
    var root = getCartDrawerRoot();
    if (!root || root.dataset.rncFreeShipObserver) return;
    root.dataset.rncFreeShipObserver = '1';

    var timer;
    var observer = new MutationObserver(function (mutations) {
      var shouldSync = mutations.some(function (mutation) {
        var nodes = [mutation.target];
        if (mutation.type === 'childList') {
          Array.prototype.forEach.call(mutation.addedNodes || [], function (node) {
            nodes.push(node);
          });
        }
        return nodes.some(function (node) {
          if (!node || node.nodeType !== 1 || typeof node.closest !== 'function') return false;
          return !node.closest('[data-rnc-free-shipping-wrap]');
        });
      });
      if (!shouldSync) return;
      clearTimeout(timer);
      timer = setTimeout(function () {
        syncDrawerFreeShippingBar(window.__rncLastCart);
      }, 80);
    });
    observer.observe(root, { childList: true, subtree: true });
    syncDrawerFreeShippingBar(window.__rncLastCart);
    setTimeout(function () {
      refreshBoosterSideCart(window.__rncLastCart, { forceRemount: true });
    }, 800);
  }

  function applyGiftRowUi() {
    document.querySelectorAll('.cart-items > li').forEach(function (li) {
      var titleEl = li.querySelector('.cart-item-product-title');
      var isGift =
        li.getAttribute('data-rnc-gift') === '1' ||
        ((titleEl && titleEl.textContent) || '').indexOf('Welcome Gift') >= 0 ||
        ((titleEl && titleEl.textContent) || '').indexOf('(Welcome Gift)') >= 0;

      if (!isGift) return;

      li.setAttribute('data-rnc-gift', '1');
      var priceEl = li.querySelector('.cart-item-price');
      if (priceEl) priceEl.innerHTML = '<span class="rnc-cart-gift-free">Free</span>';

      var removeWrap = li.querySelector('.cart-item-remove-button-container');
      if (removeWrap) removeWrap.style.display = 'none';

      var qtyWrap = li.querySelector('.cart-item--quantity-wrapper');
      if (qtyWrap) {
        qtyWrap.classList.add('rnc-cart-gift-qty--locked');
        qtyWrap.innerHTML = '';
      }
    });
  }

  function initCartDrawerGiftObserver() {
    var cartItemsEl = document.querySelector('.cart-items');
    if (!cartItemsEl || cartItemsEl.dataset.rncGiftUiObserver) return;
    cartItemsEl.dataset.rncGiftUiObserver = '1';

    var timer;
    var observer = new MutationObserver(function () {
      clearTimeout(timer);
      timer = setTimeout(applyGiftRowUi, 50);
    });
    observer.observe(cartItemsEl, { childList: true, subtree: true });
  }

  function renderCartDrawer(cart) {
    rncRenderCartDrawer(cart);
    return Promise.resolve(cart);
  }

  function openCartDrawer(cart) {
    if (cart && cart.items) {
      return refreshCartAfterAdd(cart, { openDrawer: true, refreshMode: 'fast' });
    }
    var priorCount = (window.__rncLastCart && window.__rncLastCart.item_count) || 0;
    return fetchCartJsonWhenUpdated(priorCount + 1).then(function (fresh) {
      return refreshCartAfterAdd(fresh, { openDrawer: true, refreshMode: 'fast' });
    });
  }

  function postCartItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items }),
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) {
          var msg = (data && data.description) || (data && data.message) || 'Could not add to cart';
          throw new Error(msg);
        }
        return data;
      });
    });
  }

  function updateThemeCartDrawer(cart) {
    if (cart && cartHasBundleGiftLines(cart)) {
      return syncGiftQuantities(cart).then(function (syncedCart) {
        return renderCartDrawer(syncedCart || cart);
      });
    }
    if (window.theme && typeof window.theme.updateCartDrawer === 'function') {
      return window.theme.updateCartDrawer(cart);
    }
    return renderCartDrawer(cart);
  }

  function addSubscribeLineToCart(opts) {
    var variantId = parseInt(opts.variantId, 10);
    var sellingPlanId = opts.sellingPlanId ? parseInt(opts.sellingPlanId, 10) : null;
    if (!variantId) return Promise.reject(new Error('Missing variant'));

    var item = { id: variantId, quantity: parseInt(opts.quantity, 10) || 1 };
    if (sellingPlanId) item.selling_plan = sellingPlanId;

    var priorCount = (window.__rncLastCart && window.__rncLastCart.item_count) || 0;
    var expectedCount = priorCount + item.quantity;

    return postCartItems([item]).then(function () {
      return fetchCartJsonWhenUpdated(expectedCount)
        .then(function (cart) {
          return refreshCartAfterAdd(cart, {
            openDrawer: opts.openDrawer !== false,
            refreshMode: 'fast',
          });
        })
        .catch(function (err) {
          console.warn('RNC cart drawer refresh failed after add (item was added)', err);
          resetCheckoutSpinner();
          return fetchCartJsonWhenUpdated(expectedCount).then(function (cart) {
            return refreshCartAfterAdd(cart, {
              openDrawer: opts.openDrawer !== false,
              refreshMode: 'fast',
            });
          });
        });
    });
  }

  function addGiftLinesSafely(giftLines) {
    if (!giftLines || !giftLines.length) return Promise.resolve();
    return postCartItems(giftLines).catch(function () {
      return giftLines.reduce(function (chain, gift) {
        return chain.then(function () {
          return postCartItems([gift]).catch(function (err) {
            console.warn('RNC welcome gift could not be added', gift.id, err);
            return null;
          });
        });
      }, Promise.resolve());
    });
  }

  function ensureWelcomeGiftsInCart(cart, bundleHandle, quantity) {
    if (promoDefaultOnetime()) return Promise.resolve(cart);
    if (!cart || !bundleHandle || CONFIG.customerGiftEligible === false) {
      return Promise.resolve(cart);
    }
    var hasBundleSub = (cart.items || []).some(function (item) {
      return resolveBundleHandleFromLine(item) === bundleHandle && isBundleSubscribeLine(item);
    });
    if (!hasBundleSub) return Promise.resolve(cart);
    if (cartHasWelcomeGiftForBundle(cart, bundleHandle)) return Promise.resolve(cart);

    var giftLines = getGiftLineItems(bundleHandle, quantity);
    if (!giftLines.length) return Promise.resolve(cart);

    return addGiftLinesSafely(giftLines)
      .then(function () {
        return fetchCartJson();
      })
      .catch(function () {
        return cart;
      });
  }

  function finishBundleCartAdd(opts, mainLine, giftLines) {
    var bundleHandle = opts.bundleHandle || '';
    var bundleQty = parseInt(opts.quantity, 10) || 1;
    var priorCount = (window.__rncLastCart && window.__rncLastCart.item_count) || 0;
    var expectedCount = priorCount + bundleQty;

    return postCartItems([mainLine]).then(function () {
      var chain = promoDefaultOnetime()
        ? Promise.resolve()
        : addGiftLinesSafely(giftLines);

      return chain
        .then(function () {
          return fetchCartJsonWhenUpdated(expectedCount);
        })
        .then(function (cart) {
          if (promoDefaultOnetime()) return cart;
          return ensureWelcomeGiftsInCart(cart, bundleHandle, bundleQty);
        })
        .then(function (cart) {
          if (promoDefaultOnetime()) return cart;
          return syncGiftQuantities(cart);
        })
        .then(function (cart) {
          return refreshCartAfterAdd(cart, {
            openDrawer: opts.openDrawer !== false,
            refreshMode: 'fast',
          });
        })
        .catch(function (err) {
          console.warn('RNC cart drawer refresh failed after add (item was added)', err);
          resetCheckoutSpinner();
          return fetchCartJsonWhenUpdated(expectedCount).then(function (cart) {
            return refreshCartAfterAdd(cart, {
              openDrawer: opts.openDrawer !== false,
              refreshMode: 'fast',
            });
          });
        });
    });
  }

  function buildMainBundleLine(opts) {
    var variantId = parseInt(opts.variantId, 10);
    var sellingPlanId = opts.sellingPlanId ? parseInt(opts.sellingPlanId, 10) : null;
    var bundleHandle = opts.bundleHandle || '';
    var isSubscribe = opts.isSubscribe !== false;
    var bundleQty = parseInt(opts.quantity, 10) || 1;

    var main = { id: variantId, quantity: bundleQty };
    if (isSubscribe && sellingPlanId) main.selling_plan = sellingPlanId;
    if (bundleHandle) {
      main.properties = { _rnc_bundle: bundleHandle };
      if (isSubscribe) main.properties._rnc_subscribe = '1';
    }
    return main;
  }

  function addBundleToCart(opts) {
    var bundleHandle = opts.bundleHandle || '';
    var isSubscribe = opts.isSubscribe !== false;
    var mainLine = buildMainBundleLine(opts);

    if (!isSubscribe || !bundleHandle) {
      return finishBundleCartAdd(opts, mainLine, []);
    }

    return checkGiftEligibilityAsync(bundleHandle).then(function (eligible) {
      var giftLines = eligible ? getGiftLineItems(bundleHandle, opts.quantity || 1) : [];
      return finishBundleCartAdd(opts, mainLine, giftLines);
    });
  }

  function checkGiftEligibilityAsync(bundleHandle) {
    if (promoDefaultOnetime()) return Promise.resolve(false);
    if (CONFIG.customerGiftEligible === false) {
      return Promise.resolve(false);
    }
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (bundleHandle && cartHasWelcomeGiftForBundle(cart, bundleHandle)) {
          return false;
        }
        return isEligibleForWelcomeGifts();
      })
      .catch(function () {
        return isEligibleForWelcomeGifts();
      });
  }

  var cartPageSyncTimer = null;

  function findCartPageQtyControl(index) {
    var form = document.getElementById('cartform');
    if (!form) return null;
    var inputs = form.querySelectorAll('input.quantity-selector, input[name="updates[]"]');
    if (!inputs[index]) return null;
    return inputs[index].closest('.quantity-controls') || inputs[index].parentElement;
  }

  function lockCartPageGiftRow(wrap) {
    if (!wrap) return;
    wrap.classList.add('rnc-cart-gift-qty--locked');
    wrap.setAttribute('data-rnc-gift', '1');
    var input = wrap.querySelector('input.quantity-selector, input[name="updates[]"]');
    if (input) input.setAttribute('readonly', 'readonly');
  }

  function applyCartPageGiftLocks(cart) {
    if (!cart || !cart.items) return;
    cart.items.forEach(function (item, index) {
      if (!isWelcomeGiftLine(item)) return;
      lockCartPageGiftRow(findCartPageQtyControl(index));
      var row = document.querySelector('#cartform .id-' + item.id);
      if (row) row.setAttribute('data-rnc-gift', '1');
    });
  }

  function scheduleCartPageGiftSync(reload) {
    clearTimeout(cartPageSyncTimer);
    cartPageSyncTimer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          var updates = buildGiftQuantitySyncUpdates(cart);
          if (!updates) return cart;
          return applyCartUpdates(updates).then(function (newCart) {
            if (reload !== false) window.location.reload();
            return newCart;
          });
        })
        .catch(function () {});
    }, 400);
  }

  function bindCartPageGiftControls() {
    var form = document.getElementById('cartform');
    if (!form || form.dataset.rncGiftQtyBound) return;
    form.dataset.rncGiftQtyBound = '1';

    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        if (!cart.items || !cart.items.some(isWelcomeGiftLine)) return;
        applyCartPageGiftLocks(cart);
        var updates = buildGiftQuantitySyncUpdates(cart);
        if (!updates) return;
        return applyCartUpdates(updates).then(function () {
          window.location.reload();
        });
      })
      .catch(function () {});

    form.addEventListener(
      'click',
      function (e) {
        if (e.target.closest('[data-rnc-gift="1"]') || e.target.closest('.rnc-cart-gift-qty--locked')) {
          if (e.target.closest('.qty-plus, .qty-minus, button')) {
            e.preventDefault();
            e.stopImmediatePropagation();
          }
        }
      },
      true
    );

    form.addEventListener(
      'change',
      function (e) {
        if (!e.target.matches('input.quantity-selector, input[name="updates[]"]')) return;
        if (e.target.closest('[data-rnc-gift="1"]') || e.target.closest('.rnc-cart-gift-qty--locked')) {
          e.preventDefault();
          e.stopImmediatePropagation();
        }
      },
      true
    );

    form.addEventListener(
      'click',
      function (e) {
        if (e.target.closest('.rnc-cart-gift-qty--locked') || e.target.closest('[data-rnc-gift="1"]')) return;
        if (!e.target.closest('.qty-plus, .qty-minus')) return;
        scheduleCartPageGiftSync(true);
      },
      true
    );

    form.addEventListener('change', function (e) {
      if (!e.target.matches('input.quantity-selector, input[name="updates[]"]')) return;
      if (e.target.closest('[data-rnc-gift="1"]')) return;
      scheduleCartPageGiftSync(true);
    });
  }

  function bindBundlePdpForm() {
    var page = document.querySelector('.rnc-page[data-rnc-bundle-product="1"]');
    if (!page) return;
    var form = document.getElementById('rnc-add-to-cart');
    if (!form || form.dataset.rncBundleBound) return;
    form.dataset.rncBundleBound = '1';

    form.addEventListener('submit', function (e) {
      var handle = page.getAttribute('data-product-handle') || '';
      if (!isBundleHandle(handle)) return;

      var spInput = document.getElementById('rnc-selling-plan');
      var otRadio = document.querySelector('input[name="purchaseType"][value="onetime"]');
      var isSubscribe = !(otRadio && otRadio.checked);
      if (spInput && spInput.value) isSubscribe = true;
      if (!isSubscribe) return;

      e.preventDefault();
      e.stopPropagation();

      var variantInput = form.querySelector('input[name="id"]');
      var qtyInput = document.getElementById('rnc-form-qty');
      var btn = document.getElementById('rnc-add-btn');
      var variantId = variantInput ? variantInput.value : '';
      var sellingPlanId = spInput ? spInput.value : '';
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;

      if (btn) {
        btn.disabled = true;
      }

      addBundleToCart({
        variantId: variantId,
        sellingPlanId: sellingPlanId,
        bundleHandle: handle,
        isSubscribe: true,
        quantity: qty,
        openDrawer: true,
      })
        .then(function () {
          if (btn) btn.disabled = false;
        })
        .catch(function (err) {
          if (btn) btn.disabled = false;
          alert((err && err.message) || 'Could not add to cart. Please try again.');
        });
    });
  }

  function patchThemeCartDrawer() {
    if (window.__rncCartDrawerPatched) return;
    var theme = window.theme;
    if (!theme || typeof theme.updateCartDrawer !== 'function') {
      setTimeout(patchThemeCartDrawer, 100);
      return;
    }
    window.__rncCartDrawerPatched = true;

    var origThemeUpdate = theme.updateCartDrawer.bind(theme);
    theme.updateCartDrawer = async function (cart) {
      if (cart && cartHasBundleGiftLines(cart)) {
        rncRenderCartDrawer(cart);
        return;
      }
      await origThemeUpdate(cart);
      if (cart) {
        await enhanceCartDrawerPurchaseToggles(cart);
        syncDrawerFreeShippingBar(cart);
      }
    };

    if (theme.cartDrawer && typeof theme.cartDrawer.updateCartDrawer === 'function') {
      var origDrawerUpdate = theme.cartDrawer.updateCartDrawer.bind(theme.cartDrawer);
      theme.cartDrawer.updateCartDrawer = async function (cart) {
        if (cart && cartHasBundleGiftLines(cart)) {
          rncRenderCartDrawer(cart);
          return;
        }
        await origDrawerUpdate(cart);
        if (cart) {
          await enhanceCartDrawerPurchaseToggles(cart);
          syncDrawerFreeShippingBar(cart);
        }
      };
    }
  }

  function lockWelcomeGiftPdp() {
    if (!window.__rncIsWelcomeGiftProduct) return;
    if (document.querySelector('[data-rnc-gift-pdp-locked]')) return;

    var forms = document.querySelectorAll('form[action*="/cart/add"], .shopify-product-form, #add-to-cart-form');
    var anchor = null;
    forms.forEach(function (form) {
      anchor = anchor || form;
      form.style.display = 'none';
      form.setAttribute('data-rnc-gift-pdp-locked', '1');
    });

    document
      .querySelectorAll('.product-price, .price, [data-product-price], .product__price, .product-form__buttons')
      .forEach(function (el) {
        el.style.display = 'none';
      });

    if (anchor && !document.querySelector('.rnc-gift-pdp-note')) {
      var note = document.createElement('p');
      note.className = 'rnc-gift-pdp-note';
      note.style.cssText =
        'margin:16px 0;padding:14px 16px;border:1px solid #e5e7eb;border-radius:8px;background:#f9fafb;font-size:14px;line-height:1.4;color:#374151;';
      note.textContent =
        'This is a free welcome gift included with RNC bundle subscriptions. It cannot be purchased on its own — add a wellness bundle to receive it.';
      anchor.parentNode.insertBefore(note, anchor);
    }
  }

  function softenCartPageCheckoutCta() {
    if (location.pathname.indexOf('/cart') !== 0) return;
    document.querySelectorAll('input[name="checkout"], button[name="checkout"]').forEach(function (btn) {
      var label = (btn.value || btn.textContent || '').trim();
      if (/place your order/i.test(label)) {
        if (btn.tagName === 'INPUT') {
          btn.value = 'Continue to checkout →';
        } else {
          btn.textContent = 'Continue to checkout →';
        }
      }
    });
  }

  function initRncBundleGifts() {
    lockWelcomeGiftPdp();
    initSearchPageScrub();
    bindBundlePdpForm();
    bindCartLineGuards();
    bindCartPurchaseToggle();
    bindCartPageGiftControls();
    patchThemeCartDrawer();
    initCartDrawerGiftObserver();
    initCartDrawerDedupeObserver();
    initDrawerFreeShippingObserver();
    applyGiftRowUi();
    softenCartPageCheckoutCta();

    if (window.__rncQueuedDrawerCart) {
      rncRenderCartDrawer(window.__rncQueuedDrawerCart);
      window.__rncQueuedDrawerCart = null;
    } else {
      var initial = document.getElementById('initial-cart');
      if (initial) {
        try {
          var initialCart = JSON.parse(initial.textContent);
          if (cartHasBundleGiftLines(initialCart)) {
            scheduleCartDrawerRepaint(initialCart);
          }
        } catch (e) {}
      }
    }

    var initCart = window.__rncLastCart;
    if (!initCart) {
      var initialEl = document.getElementById('initial-cart');
      if (initialEl) {
        try {
          initCart = JSON.parse(initialEl.textContent);
          window.__rncLastCart = initCart;
        } catch (e) {}
      }
    }
    syncDrawerFreeShippingBar(initCart);
    if (initCart) {
      enhanceCartPagePurchaseToggles(initCart);
    }

    fetch('/cart.js', { credentials: 'same-origin' })
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          window.__rncLastCart = cart;
          if (cartHasBundleGiftLines(cart)) {
            return syncGiftQuantitiesAndRender(cart);
          }
          syncDrawerFreeShippingBar(cart);
          return enhanceCartPagePurchaseToggles(cart);
        })
        .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRncBundleGifts);
  } else {
    initRncBundleGifts();
  }

  window.RNC_BUNDLE_GIFTS = Object.assign(window.RNC_BUNDLE_GIFTS || {}, {
    config: CONFIG,
    promoDefaultOnetime: promoDefaultOnetime,
    isBundleHandle: isBundleHandle,
    resolveSellingPlanId: resolveSellingPlanId,
    resolveFirstSellingPlanId: resolveFirstSellingPlanId,
    getCadenceForHandle: getCadenceForHandle,
    productHasSubscribePlans: productHasSubscribePlans,
    resolveSubscribeGridPrices: resolveSubscribeGridPrices,
    getGiftLineItems: getGiftLineItems,
    buildCartItems: buildCartItems,
    addBundleToCart: addBundleToCart,
    addSubscribeLineToCart: addSubscribeLineToCart,
    openCartDrawer: openCartDrawer,
    refreshCartDrawer: refreshCartDrawer,
    rncRenderCartDrawer: rncRenderCartDrawer,
    isEligibleForWelcomeGifts: isEligibleForWelcomeGifts,
    checkGiftEligibilityAsync: checkGiftEligibilityAsync,
    buildCascadeRemovalUpdates: buildCascadeRemovalUpdates,
    getBundleQtyByHandle: getBundleQtyByHandle,
    buildGiftQuantitySyncUpdates: buildGiftQuantitySyncUpdates,
    syncGiftQuantities: syncGiftQuantities,
    syncGiftQuantitiesAndRender: syncGiftQuantitiesAndRender,
    scheduleCartDrawerRepaint: scheduleCartDrawerRepaint,
  });
})();
